import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {EMPTY, Observable} from "rxjs";
import {AppState} from "../state/app.state";
import {Store} from "@ngrx/store";
import {deliveryTokenSelector, getWarehouseOrderId,checkIfOrderIdInParams,getOrderIdForTimeline,getDocketId} from "../state/home/home.selector";

@Injectable({
    providedIn: 'root'
}
)
export class TokenInterceptor implements HttpInterceptor {
  token = '';
  wareHouseToken = ''
  isOrderId =''
  orderIdForTimeline = ''
  docketId = ''
  constructor(private store: Store<AppState>) {
    this.store.select(deliveryTokenSelector).subscribe(t => this.token = t);
    this.store.select(getWarehouseOrderId).subscribe(t => this.wareHouseToken = t);
    this.store.select(checkIfOrderIdInParams).subscribe(t => this.isOrderId = t)
    this.store.select(getOrderIdForTimeline).subscribe(t => this.orderIdForTimeline = t)
    this.store.select(getDocketId).subscribe(t => this.docketId = t)
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.token && !this.wareHouseToken && !this.isOrderId && !this.orderIdForTimeline && !this.docketId) {
      return EMPTY
    }

    if(this.wareHouseToken){
      const modifiedReq = req.clone({
        params: req.params.set('warehouseOrderId', this.wareHouseToken)
      });
      return next.handle(req);
    }
    if(this.orderIdForTimeline){
      const modifiedReq = req.clone({
        params: req.params.set('orderIdForTimeline', this.orderIdForTimeline)
      });
      return next.handle(modifiedReq)
    }
    if(this.docketId){
      const modifiedReq = req.clone({
        params: req.params.set('docketId', this.docketId)
      });
      return next.handle(modifiedReq)
    }
    if(this.isOrderId){
      const modifiedReq = req.clone({
        params: req.params.set('orderId', this.isOrderId)
      });
      return next.handle(modifiedReq)
    }

    const modifiedReq = req.clone({
      params: req.params.set('deliveryTokenId', this.token)
    });
    return next.handle(modifiedReq);
  }
}
